var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdealWero = function SvgIdealWero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ideal_wero_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 182"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ideal_wero_svg__linear-gradient",
    x1: 352.72,
    y1: 95.3,
    x2: 330.2,
    y2: 67.73,
    gradientTransform: "matrix(1 0 0 -1 0 184)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1d1c1c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1d1c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ideal_wero_svg__linear-gradient-2",
    x1: 313.44,
    y1: 89.45,
    x2: 336.52,
    y2: 112.26,
    gradientTransform: "matrix(1 0 0 -1 0 184)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1d1c1c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#1d1c1c"
  })), /*#__PURE__*/React.createElement("style", null, ".ideal_wero_svg__cls-3,.ideal_wero_svg__cls-5,.ideal_wero_svg__cls-6,.ideal_wero_svg__cls-8{stroke-width:0}.ideal_wero_svg__cls-3{fill-rule:evenodd}.ideal_wero_svg__cls-6{fill:#232323}.ideal_wero_svg__cls-3,.ideal_wero_svg__cls-8{fill:#fff}.ideal_wero_svg__cls-5{fill:#1d1c1c}"))), /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 182,
    rx: 13,
    ry: 13,
    style: {
      fill: "#fff48d",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ideal_wero_svg__cls-8",
    d: "M11.02 22.87v136.4c0 6.53 5.37 11.87 11.93 11.87h81.89c61.91 0 88.74-34.49 88.74-80.25S166.74 11 104.83 11H22.94c-6.56 0-11.93 5.34-11.93 11.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.83 44.48v100.79h44.07c40.02 0 57.37-22.5 57.37-54.31s-17.36-54.07-57.37-54.07H73.46c-4.23 0-7.63 3.44-7.63 7.6Z",
    style: {
      fill: "#c06",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.62 160.28h71.21c50.04 0 77.65-24.63 77.65-69.33 0-25.76-10.08-69.03-77.65-69.03H33.62c-6.32 0-11.45 5.1-11.45 11.4v115.57c0 6.29 5.13 11.4 11.45 11.4ZM25.98 33.32c0-4.21 3.4-7.6 7.63-7.6h71.21c27.55 0 73.83 8.49 73.83 65.23 0 42.26-26.24 65.53-73.83 65.53h-71.2c-4.23 0-7.63-3.38-7.63-7.6V33.32Z",
    style: {
      fill: "#232323",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ideal_wero_svg__cls-3",
    d: "M87.51 76.3c-1.34-.48-2.74-.72-4.26-.72v-.06H73.16v24.34h10.21c1.81 0 3.38-.36 4.73-.96 1.34-.66 2.45-1.5 3.33-2.58.88-1.08 1.52-2.4 1.98-3.9.41-1.5.64-3.12.64-4.92 0-2.04-.29-3.78-.82-5.28-.58-1.44-1.34-2.7-2.27-3.72-.99-.96-2.1-1.74-3.44-2.22Zm-2.39 18.77c-.76.24-1.46.36-2.22.36v.06h-4.61V80.14h3.73c1.28 0 2.33.18 3.21.54.88.36 1.58.96 2.1 1.62.52.66.93 1.56 1.17 2.52.23.96.35 2.1.35 3.3 0 1.38-.18 2.46-.52 3.42a7.12 7.12 0 0 1-1.34 2.28 4.32 4.32 0 0 1-1.87 1.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ideal_wero_svg__cls-8",
    d: "M115.11 75.59v4.5h-12.49v5.22h11.49v4.14h-11.49v5.94h12.78v4.5H97.43V75.55h17.68v.06Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ideal_wero_svg__cls-3",
    d: "m141.83 99.93-8.87-24.34h-5.42l-8.93 24.34h5.25l1.87-5.4h8.87l1.81 5.4h5.43Zm-11.56-18.35 2.98 8.93h-6.12l3.09-8.93h.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ideal_wero_svg__cls-8",
    d: "M150.29 75.58v19.85h11.55v4.5H145.1V75.59h5.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ideal_wero_svg__cls-6",
    d: "M45.35 100.29c6.32 0 11.44-5.12 11.44-11.45s-5.12-11.45-11.44-11.45-11.44 5.12-11.44 11.45 5.12 11.45 11.44 11.45ZM52.16 146.08c-8.86 0-15.96-7.65-15.96-17.05v-13.31c0-4.7 3.55-8.56 8.01-8.56s8.01 3.8 8.01 8.56v30.36h-.06Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ideal_wero_svg__cls-5",
    d: "M405.6 91.62c0-13.38 9.52-25.57 25.96-25.57s26.03 12.2 26.03 25.57-9.52 25.57-26.03 25.57c-16.44 0-25.96-12.2-25.96-25.57Zm37.54 0c0-6.45-4.25-12.4-11.58-12.4s-11.58 5.96-11.58 12.4 4.32 12.41 11.58 12.41 11.58-5.96 11.58-12.41ZM395.49 101.12c5.48-3.12 8.77-9.08 8.77-15.66 0-9.77-7.06-18.09-18.02-18.09h-23.01v48.51h14.25v-12.4h2.67l8.15 12.4h16.78l-9.59-14.76Zm-12.12-8.81h-5.89V78.59h5.96c3.84 0 6.3 3.12 6.3 6.86s-2.54 6.86-6.37 6.86ZM298.18 67.31l-8.55 28.91-8.34-28.91h-11.35l-8.41 28.91-8.48-28.91h-15.04l17.23 48.42h12.37l8-26.36 7.93 26.36h12.44l17.23-48.42h-15.04ZM334.78 103.91h-.03c-5.33 0-9.07-3.22-10.67-7.48h36.21c.29-1.6.44-3.24.44-4.9 0-13.34-9.49-25.51-25.95-25.52v13.14c5.36.01 9.06 3.23 10.65 7.48h-36.16c-.29 1.6-.44 3.24-.44 4.9 0 13.35 9.5 25.53 25.91 25.53h.03v-13.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.75 117.05c.56 0 1.11-.02 1.65-.04 3.33-.17 6.36-.85 9.06-1.94 2.7-1.09 5.07-2.6 7.08-4.42a23.98 23.98 0 0 0 4.97-6.3c1.17-2.14 2.03-4.45 2.57-6.86h-15.09c-.31.64-.67 1.26-1.08 1.83-.56.79-1.22 1.5-1.97 2.11-.75.62-1.59 1.14-2.51 1.54-.92.4-1.93.68-3.02.83-.53.07-1.08.11-1.65.11-3.39 0-6.14-1.31-8.11-3.36l-9.81 9.92c4.36 4.03 10.41 6.57 17.91 6.57Z",
    style: {
      strokeWidth: 0,
      fill: "url(#ideal_wero_svg__linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.75 66c-13.92 0-22.87 8.76-25.26 19.56h15.04c1.8-3.72 5.34-6.42 10.22-6.42 3.89 0 6.91 1.68 8.88 4.22l9.9-10.01c-4.42-4.48-10.78-7.35-18.77-7.35Z",
    style: {
      fill: "url(#ideal_wero_svg__linear-gradient-2)",
      strokeWidth: 0
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ideal_wero_svg__cls-5",
    d: "M215.61 145c-1.1 0-2-.9-2-2V39c0-1.1.9-2 2-2s2 .9 2 2v104c0 1.1-.9 2-2 2Z"
  })));
};
export default SvgIdealWero;